import { validationFunctions } from '../../taboola-common-frontend-modules/validations';
import { DYNAMIC_REPORT_MAX_NAME_LENGTH } from '../components/DynamicReportNameEditor/DynamicReportNameEditor';

export const dynamicReportsNameValidations = [
    {
        validationFn: validationFunctions.isNotEmptyString,
        messageId: 'validations.error.dynamic.report.name.empty',
        defaultMessage: 'Enter a Report Name',
    },
    {
        validationFn: validationFunctions.isLength,
        options: { max: DYNAMIC_REPORT_MAX_NAME_LENGTH },
        messageId: 'validations.error.dynamic.report.name.length',
        defaultMessage: 'Report name can not exceed {max} characters',
    },
];
